export default __webpack_public_path__ + "static/media/plasticbody.1eac24a2.png";